import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientSettings } from '../models/client';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  apiUrl = 'v1/settings';

  constructor(private http: HttpClient) { }

  public getSettings() {
    return this.http.get<ClientSettings>(environment.apiUrl + this.apiUrl);
  }

  public updateSettings(settings: ClientSettings) {
    return this.http.put<ClientSettings>(environment.apiUrl + this.apiUrl, settings);
  }
  
}
